<template>
  <div class="pt-24">
    <AppFaq :heading="configData.Title" :data="qaList"></AppFaq>
  </div>
</template>

<script lang="ts" setup>
import type { FaqQA } from '../AppFaq.vue';

interface Props {
  configData: {
    Title?: string;
    Questions: any[];
  };
}

const props = defineProps<Props>();

let qaList: FaqQA[] = [];
if (props.configData.Questions && props.configData.Questions.length > 0) {
  qaList = props.configData.Questions.map((Question: any) => ({
    q: Question.Question,
    a: Question.Answer,
  }));
}
</script>

<style scoped></style>
